import type { GeocodedPlace } from "src/GeocodedPlace";
import type { TripPlannerDetails } from "../TripPlannerProvider";

export function getLastTripPlannerPlace(
  tripPlannerDetails: TripPlannerDetails,
) {
  return tripPlannerDetails.places[tripPlannerDetails.places.length - 1] as
    | GeocodedPlace
    | undefined;
}
